import React, { useState, useEffect } from 'react';

import { useLinkTo, useUserState } from '../../../../hooks';
import { PROVIDER_SEARCH_RANK } from '../../../../route-names';

import NcdNonPaymentAppointmentNotification, { NotificationProps } from './NcdNonPaymentAppointmentNotification';

type ContainerProps = {
  notification: NotificationProps;
};

const Container: React.FC<ContainerProps> = ({
  notification,
}) => {
  const [
    appointments, setAppointments, appointmentsLoaded,
  ] = useUserState<object>('ncd-non-payment-appointment-notification');
  const [canShow, setCanShow] = useState<boolean>(false);

  const updateAppointments = () => {
    const now = Date.now();
    const currentAppointments = {};
    if (typeof appointments === 'object' && appointments !== null) {
      Object.entries(appointments).forEach(([key, value]) => {
        const notificationDate = Date.parse(value);
        const notificationAge = (now - notificationDate) / (1000 * 60 * 60 * 24);
        if (notificationAge < 30) {
          currentAppointments[key] = value;
        }
      });
    }
    currentAppointments[notification.appointment_id] = notification.creation_time;
    setAppointments(currentAppointments);
  };

  const linkTo = useLinkTo();
  const onClick = () => {
    updateAppointments();
    setCanShow(false);
    linkTo(PROVIDER_SEARCH_RANK, {
      providerId: notification.provider_id,
      source: 'notification',
    });
  };

  useEffect(() => {
    if (!appointmentsLoaded) return;
    const validatedAppointments = appointments || {};
    if ((notification.appointment_id in validatedAppointments)) return;
    setCanShow(true);
  }, [
    appointmentsLoaded,
    appointments,
    notification,
  ]);

  return (
    canShow && (
      <NcdNonPaymentAppointmentNotification
        notification={notification}
        onClick={onClick}
      />
    )
  );
};

export default Container;
